<template>
    <div class="ah-page currency-page">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>幣別與匯率</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body" style="background-color: #f6f6f6">
                    <el-row>
                        <el-col :sm="12">
                            <span style="font-size: 12pt; margin-left: 16px;vertical-align: top;">{{ new Date().getTime() | dateFormater("YYYY 年 MM 月 dd 日") }}</span>
                        </el-col>
                        <el-col :sm="12" style="text-align: right;">
                            <el-tag type="warning">臺灣銀行即期匯率，每日上午 6:00 自動更新，僅供參考不代表實際交易匯率</el-tag>
                        </el-col>
                    </el-row>
                </div>
                <div class="panel-body">
                    <el-table v-loading="status == 'loading'" :data="datas" style="width: 100%" class="currency-table ah-el-data-table" empty-text="沒有資料">
                        <el-table-column prop="cnynam" label="幣別" min-width="30">
                            <template slot-scope="scope">
                                <div class="strong">{{ scope.row.cnynam }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cny" label="代號"> </el-table-column>
                        <el-table-column prop="rat" label="匯率" align="right">
                            <template slot-scope="scope">
                                <div style="font-weight: bold;">{{ scope.row.rat }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="left" width="110">
                            <template slot-scope="scope">
                                <el-button size="small" @click="handleDataRowClick(scope.row)" v-if="scope.row.cny != 'TWD' && !isQR()">修改匯率</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <EditDialog v-if="showEditDialog" :visible="showEditDialog" :inputObject="selectedItem" @close="updateList" />
        </div>
    </div>
</template>
<script>
import EditDialog from './EditDialog';

export default {
    name: 'SpecialDisbursementProjectPage',
    components: {
        EditDialog,
    },
    data() {
        return {
            showEditDialog: false,
            status: '',
            selectedItem: {},
            datas: [],
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        // 按下表格一行
        handleDataRowClick(data) {
            this.selectedItem = data;
            this.showEditDialog = true;
        },

        // 關閉詳細資料後
        handleDetailDialogClose() {},

        updateData() {
            this.status = 'loading';

            // 開始取得資料
            this.$api({
                url: 'CurrencyManagementPage/GetList',
                method: 'GET',
            })
                // 取得成功
                .then((resp) => {
                    this.status = 'success';

                    // 更新資料
                    this.datas = resp.data.items;
                });
        },

        // 顯示錯誤訊息
        showErrorMsg(msg) {
            this.errorMsg = msg;
        },
        updateList(value) {
            if (value) {
                this.selectedItem.rat = value;
                this.$api({
                    url: 'CurrencyManagementPage/UpdateList',
                    method: 'POST',
                    data: { items: this.datas },
                })
                    // 取得成功
                    .then(() => {
                        this.showEditDialog = false;
                        this.updateData();
                    });
            } else {
                this.showEditDialog = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";
</style>
